"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import CommonSwitch from "@/components/utils/switch/CommonSwitch";
import { useShowFollowingWaves } from "@/hooks/useShowFollowingWaves";
import { useAuth } from "@/components/auth/Auth";

// Pure helper function for authentication state logic (testable)
const checkConnectedIdentity = (connectedHandle: string | null | undefined, activeProfileProxy: unknown): boolean => {
  return !!connectedHandle && !activeProfileProxy;
};

/**
 * JoinedToggle component that renders a switch to filter waves by joined status.
 * Only renders when the user is authenticated with a connected identity (not using a proxy).
 * Uses localStorage to persist the toggle state across sessions.
 * 
 * @returns JSX element containing the toggle switch, or null if user is not authenticated or on error
 */
const JoinedToggle = () => {
  const $ = _c(7);
  const followingHookResult = useShowFollowingWaves();
  const authResult = useAuth();
  let t0;
  if ($[0] !== followingHookResult) {
    t0 = followingHookResult || [false, _temp];
    $[0] = followingHookResult;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [following, setFollowing] = t0;
  let t1;
  if ($[2] !== authResult) {
    t1 = authResult || {};
    $[2] = authResult;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    connectedProfile,
    activeProfileProxy
  } = t1;
  const connectedHandle = connectedProfile?.handle;
  const isConnectedIdentity = checkConnectedIdentity(connectedHandle, activeProfileProxy);
  if (!followingHookResult) {
    console.warn("[JoinedToggle] useShowFollowingWaves hook failed - component will not render", {
      component: "JoinedToggle",
      error: "hook_failure",
      hook: "useShowFollowingWaves"
    });
    return null;
  }
  if (!isConnectedIdentity) {
    return null;
  }
  ;
  try {
    let t3;
    if ($[4] !== following || $[5] !== setFollowing) {
      t3 = <CommonSwitch label="Joined" isOn={following} setIsOn={setFollowing} />;
      $[4] = following;
      $[5] = setFollowing;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  } catch (t2) {
    const error = t2;
    console.warn("[JoinedToggle] Rendering error occurred", {
      component: "JoinedToggle",
      error: "rendering_failure",
      errorMessage: error instanceof Error ? error.message : String(error),
      following,
      connectedHandle: !!connectedHandle
    });
    return null;
  }
};
JoinedToggle.displayName = "JoinedToggle";
export default JoinedToggle;
function _temp() {}